import { useCallback, useEffect, useRef } from 'react';

// HOOK: returns a stable getter for whether the component is still mounted — call it in async
// continuations (promise .then/.catch, awaiting callbacks) before setState to skip post-unmount updates.
export const useIsMounted = (): (() => boolean) => {
  const mountedRef = useRef(true);
  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);
  return useCallback(() => mountedRef.current, []);
};
